<template>
  <div class="headerTabs">
    <router-link to="/" class="headerLink">首页</router-link>
    <router-link to="/course" class="headerLink">课程中心</router-link>
    <router-link to="/news" class="headerLink">资讯中心</router-link>
    <router-link to="/about" class="headerLink" @click="contactUs">联系我们</router-link>
    <router-link to="/about" class="headerLink" @click="platformIntro">平台介绍</router-link>
  </div>
</template>

<script>
export default {
  methods: {
    contactUs() {
      this.$store.commit('aboutUsItemSelected', "联系我们");
    },
    platformIntro() {
      this.$store.commit('aboutUsItemSelected', "平台介绍");
    }
  },
}
</script>

<style spoed>
.headerTabs {
  margin-top: 17px;
  margin-right: 30px;
  float: left;
}

.headerTabs .headerLink {
  display: inline-block;
  border-radius: 4px;
  background-color: #fff;
  color: #151515;
  cursor: pointer;
  padding: 8px 15px;
  text-align: center;
  font-size: 14px;
}

.headerTabs .headerLink:hover {
  color: var(--link-hover-color);
}

/* .headerTabs .headerLink.active {
  background-color: var(--link-color);
  color: #fff;
  cursor: default;
} */
</style>